const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/usz/eCheckin/sections/HausArzt.tsx';
import { forwardRef } from 'react';
import _ from 'lodash';
import { CIS4mSingleCheckbox } from '@cistec/common_web/modules/CIS4m/components/CIS4mSingleCheckbox';
import { useCIS4m, useCIS4mData } from '@cistec/common_web/modules/CIS4m/hooks';
import { useText } from '@cistec/common_web/utils/intlUtils';
import ECheckinSection from 'App/components/eCheckin/components/ECheckinSection';
import { AddressFieldsConfig } from 'App/components/eCheckin/components/fields/AddressBlock';
import { ArztBlock, ArztFieldsConfig } from 'App/components/eCheckin/components/fields/ArztBlock';
import { ECheckinSectionProps } from 'App/components/eCheckin/types';
import { generatePaths } from 'App/components/eCheckin/utils';
import textMap from '../translations';

const addressFieldsConfig: AddressFieldsConfig = {
    additionalInfo: {
        included: false,
    },
    streetAndNumber: {
        required: false,
    },
    country: {
        included: false,
    },
};

const fieldsConfig: ArztFieldsConfig = {
    tel: {
        required: false,
    },
};

export const HausArzt = forwardRef((props: ECheckinSectionProps, ref: any) => {
    const { path } = props;
    const title = useText(props.title);

    const PATHS = generatePaths(path, ['noFamilyDoctor'] as const);

    const formData = useCIS4mData();
    const noFamilyDoctor = _.get(formData, PATHS.noFamilyDoctor) === '1';

    const eCheckinSectionRef = useCIS4m(ref);

    return (
        <ECheckinSection ref={eCheckinSectionRef} path={path} title={title}>
            <h1>{title}</h1>
            <CIS4mSingleCheckbox label={textMap.keinHausarzt} path={PATHS.noFamilyDoctor} />
            <ArztBlock
                basePath={path}
                fieldsConfig={fieldsConfig}
                addressFieldsConfig={addressFieldsConfig}
                hidden={noFamilyDoctor}
                required
            />
        </ECheckinSection>
    );
});

HausArzt.displayName = 'HausArzt';

export default HausArzt;
